import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { map } from 'lodash';
import { saveToSessionStorage, removeFromSessionStorage } from
  '@codex/helpers';
import detectVariants from '@dc/fo-experiment/lib/detectVariants.js';
import { addProduct, removeProduct } from '../../../appState/ducks/comparison';
import ComparePanel from './ComparePanel.jsx';
import constants from '../constants';
import {
  dispatchClickCompareButton,
  dispatchClickProductImage,
  dispatchUncheckProduct,
  dispatchComparisonCheckClick
} from '../../../analytics';
import {
  comparePopupRequestAction,
  toggleComparePopup,
  removeItemComparePopup
} from '../../../appState/ducks/compareProducts';

class CompareBlock extends React.Component {
  constructor(props) {
    super(props);

    this.addProduct = this.addProduct.bind(this);
    this.removeProduct = this.removeProduct.bind(this);
    this.onCompareButtonClick = this.onCompareButtonClick.bind(this);
    this.onClickProductImage = this.onClickProductImage.bind(this);
  }

  onCompareButtonClick(e) {
    const productIds = map(this.props.products, (product) => product.id);
    dispatchClickCompareButton(productIds);

    // saves url pathname of current listing or product page to session storage
    // which is used in backButton on compare page
    saveToSessionStorage(
      constants.SESSION_STORAGE_COMPARISON_LAST_PAGE_PATH,
      window.location.pathname
    );
    removeFromSessionStorage(
      constants.SESSION_STORAGE_COMPARISON_BACK_LINK_LABEL
    );

    const configuration = typeof window !== 'undefined' ? {
      ...window.EXPT_CONFIG,
      QUERY: window.location.search
    } : {};

    if (detectVariants('comparePopup', configuration) === 'A') {
      comparePopupRequestAction(productIds.join(','));
      this.props.toggleComparePopup(true);
      e.preventDefault();
      return false;
    }

    const containerFormEl = document.querySelector('form[data-component="compareForm"]') || null;
    return containerFormEl && containerFormEl.submit();
  }

  onClickProductImage(product) {
    dispatchClickProductImage(product);
  }

  removeProduct(product) {
    const { productSegmentId, removeProduct, removeItemComparePopup } = this.props;
    removeProduct({ product, productSegmentId: productSegmentId });
    removeItemComparePopup(product.id);
    dispatchUncheckProduct(product);

    // remove product from session storage
    removeFromSessionStorage(product);
  }

  addProduct(product) {
    this.props.addProduct({ product, productSegmentId: this.props.productSegmentId });
    dispatchComparisonCheckClick(product.id, 'checked', '');
  }

  render() {
    const { products, translations } = this.props;

    return (
      <ComparePanel
        translations={translations}
        products={products}
        onAddProduct={this.addProduct}
        onRemoveProduct={this.removeProduct}
        onPopupDisplay={this.onClickProductImage}
        buttonClick={this.onCompareButtonClick}
      />
    );
  }
}

CompareBlock.propTypes = {
  productSegmentId: PropTypes.PropTypes.number.isRequired,
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  products: PropTypes.arrayOf(PropTypes.object),
  removeProduct: PropTypes.func,
  removeItemComparePopup: PropTypes.func.isRequired,
  addProduct: PropTypes.func,
  toggleComparePopup: PropTypes.func.isRequired
};

CompareBlock.defaultProps = {
  products: [],
  removeProduct: () => {},
  addProduct: () => {}
};

function mapStateToProps(state) {
  const currentPageSegmentId =
    window.digitalData.page.category &&
    window.digitalData.page.category.segmentId;
  return {
    products: state.listingPage.comparison.products[currentPageSegmentId] || [],
    productSegmentId: currentPageSegmentId
  };
}

export default connect(mapStateToProps, {
  addProduct,
  removeProduct,
  toggleComparePopup,
  removeItemComparePopup
})(CompareBlock);
